<template>
  <a-drawer width="60%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('上门服务公告.公告标题')" prop="title">
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('通用.输入.请输入') + $t('上门服务公告.公告标题')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务公告.公告简介')" prop="intro">
        <a-textarea v-model="form.intro" :maxLength="500" :rows="3" :placeholder="$t('通用.输入.请输入') + $t('上门服务公告.公告简介')" allow-clear />
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务公告.公告内容')" prop="content">
        <editor v-model="form.content" :height="300" />
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务公告.分类')" prop="category">
        <a-select v-model="form.category" :placeholder="$t('通用.输入.请选择') + $t('上门服务公告.分类')" style="width: 200px">
          <a-select-option v-for="(item, index) in customDict.NoticeCategoryEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务公告.排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="9999" style="width: 200px" />
        <span style="margin-left: 10px; color: #999">数字越大越靠前</span>
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务公告.备注')" prop="remark">
        <a-textarea v-model="form.remark" :rows="2" :placeholder="$t('通用.输入.请输入') + $t('上门服务公告.备注')" allow-clear />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
          <a-button @click="cancel">{{ $t('通用.按钮.取消') }}</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getNotice, addNotice, updateNotice } from '@/api/homeservice/notice'
import { mapGetters } from 'vuex'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  components: { Editor },
  data() {
    return {
      open: false,
      formType: 1,
      submitLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      form: {
        id: null,
        title: null,
        intro: null,
        content: null,
        category: 1,
        sort: 0,
        remark: null
      },
      rules: {
        title: [{ required: true, message: this.$t('上门服务公告.公告标题') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        category: [{ required: true, message: this.$t('上门服务公告.分类') + this.$t('通用.文本.不能为空'), trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict']),
    formTitle() {
      return this.formType === 1 ? this.$t('通用.按钮.新增') : this.$t('通用.按钮.修改')
    }
  },
  methods: {
    handleAdd() {
      this.open = true
      this.formType = 1
      this.reset()
    },
    handleUpdate(row) {
      this.open = true
      this.formType = 2
      this.reset()
      getNotice({ id: row.id }).then(response => {
        this.form = response.data
      })
    },
    reset() {
      this.form = {
        id: null,
        title: null,
        intro: null,
        content: null,
        category: 1,
        sort: 0,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            updateNotice(this.form).then(() => {
              this.$message.success(this.$t('通用.文本.修改成功'))
              this.onClose()
              this.$emit('ok')
            }).finally(() => { this.submitLoading = false })
          } else {
            addNotice(this.form).then(() => {
              this.$message.success(this.$t('通用.文本.新增成功'))
              this.onClose()
              this.$emit('ok')
            }).finally(() => { this.submitLoading = false })
          }
        }
      })
    },
    cancel() {
      this.onClose()
    },
    onClose() {
      this.open = false
      this.reset()
    }
  }
}
</script>

<style scoped>
/* 覆盖富文本编辑器默认高度 */
::v-deep .adaptive {
  height: auto;
}
::v-deep .editor .w-e-text-container {
  height: 300px !important;
}
</style>
